"use client";

import { useState } from "react";

interface LoadedValue<Value> {
  identity: string;
  value: Value;
}

export function useLastLoaded<Value>(
  value: Value | undefined,
  identity: string,
): Value | undefined {
  const [held, setHeld] = useState<LoadedValue<Value> | null>(null);
  if (
    value !== undefined &&
    (held === null || held.value !== value || held.identity !== identity)
  ) {
    setHeld({ identity, value });
  }
  if (value !== undefined) return value;
  return held?.identity === identity ? held.value : undefined;
}
